// extracted by mini-css-extract-plugin
export default {"dark-theme":"SearchHabits_dark-theme__l7JuL","input":"SearchHabits_input__CD5um"};